import { render, staticRenderFns } from "./listaTaxaEventos.vue?vue&type=template&id=af74fa94&scoped=true&"
import script from "./listaTaxaEventos.vue?vue&type=script&lang=js&"
export * from "./listaTaxaEventos.vue?vue&type=script&lang=js&"
import style0 from "./listaTaxaEventos.vue?vue&type=style&index=0&id=af74fa94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af74fa94",
  null
  
)

export default component.exports